import { TruckIcon, MapPinIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";
import OptionCard from "../OptionCard";
import CheckedList from "../CheckedList";

export default function Step3Delivery({ value, onNext, onBack }) {
  const [selectedValue, setSelectedValue] = useState(value || "");

  const handleSelect = (delivery) => {
    setSelectedValue(delivery);
  };

  const handleNext = () => {
    if (selectedValue) {
      onNext({ delivery: selectedValue });
    }
  };
  return (
    <div className="space-y-6">
      <StepHeader
        title="Wie möchtest du deine Fotobox erhalten?"
        description="Wir zeigen dir passende Optionen für deine Region."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <OptionCard
          isSelected={selectedValue === "regional"}
          onClick={() => handleSelect("regional")}
          icon={MapPinIcon}
          label="Regionaler Anbieter"
          description=""
          extra={
            <CheckedList
              items={[
                "Aufbau und Abbau durch den Anbieter",
                "Technischer Support vor Ort",
                "Verfuegbarkeit wird per PLZ geprueft",
              ]}
            />
          }
        />

        <OptionCard
          isSelected={selectedValue === "shipping"}
          onClick={() => handleSelect("shipping")}
          icon={TruckIcon}
          label="Fotobox per Post"
          badge="Am beliebtesten"
          description=""
          extra={
            <CheckedList
              items={[
                "Lieferung deutschlandweit",
                "Grosse Auswahl an Fotoboxen",
                "Selbstaufbau in wenigen Minuten",
              ]}
            />
          }
        />
      </div>

      {/* Navigation */}
      <WizardNavigation
        onBack={onBack}
        onNext={handleNext}
        disableNext={!selectedValue}
      />
    </div>
  );
}
